import { PeopleDirectoryPage } from "@/components/people/people-directory-page";

/** Directory — immutable people catalog search. */
export function DirectoryPeoplePage() {
  return <PeopleDirectoryPage scope="directory" />;
}
